<script>
export default {
    name: "AllPatientsReportPrint",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchAllPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchAllPatients() {

            return this.$http.get(`PatientsReports/GetPatientListPagination?page=${this.$route.query.page}&pagesize=${this.$route.query.pageSize}`).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="flex-1 text-center my-2">
            <h5 class="font-medium uppercase">All Patients Report</h5>
        </div>
        <table class="table">
            <thead class="font-medium text-xs">
                <tr>
                  <th>ID</th>
                  <th>Names</th>
                  <th>IP. NO.</th>
                  <th>OP NO</th>
                  <th>ID NO</th>
                  <th>DOB</th>
                  <th>Cell Phone</th>
                  <th>InPatient</th>
                  <th>Visits(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(patient, idx) in patients" :key="idx">
                    <td>{{ patient.patienT_ID }}</td>
                    <td>{{ patient.names }}</td>
                    <td>{{ patient.ipfileno }}</td>
                    <td>{{ patient.opfileno }}</td>
                    <td>{{ patient.nationalid }}</td>
                    <td>{{ patient.dob | dateFormat }}</td>
                    <td>{{ patient.celL_PHONE }}</td>
                    <td>{{ patient.iS_IN_PATIENT == `False` ? `No` : `Yes` }}</td>
                    <td>{{ patient.visitCount }}</td>
                </tr>
                <tr>
                    <td colspan="9" class="text-right">Total Patients: {{ patients.length }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>